import NotificationActiveIcon from 'assets/img/icons/notification-active.svg';
import NotificationIcon from 'assets/img/icons/notification.svg';
import 'components/layouts/notification/index.scss';
import { useOuterClick } from 'providers/OutsideClick';
import { useMemo, useReducer, useState } from 'react';
import PopUpListNotif from './popUpListNotif';
import SeekNotification from './seekNotification';
import useFetchNotification from './useFetchNotification';

export type DataNotification = {
  notification_id: string;
  member_id: string;
  company_id: string;
  title: string;
  message: string;
  notification_type: string;
  read_at: null;
  created_at: null;
  is_read: boolean;
  feature: string;
  feature_key: string
}[];

function Index() {
  const initialStatus = {
    seekList: false,
    fullList: false,
  };
  const reducer = (
    state: typeof initialStatus,
    action: { type: 'showSeekList' | 'showFullList'; payload: boolean },
  ) => {
    switch (action.type) {
      case 'showSeekList':
        return {
          ...state,
          seekList: action.payload,
        };
      case 'showFullList':
        return {
          ...state,
          fullList: action.payload,
        };
      default:
        return state;
    }
  };
  const [isOpened, setIsOpened] = useReducer(reducer, initialStatus);
  const [allOfDataLoaded, setAllOfDataLoaded] = useState({
    unread: {
      allLoaded: false,
    },
    read: {
      allLoaded: false,
    },
  });
  const handleStatusNotification = () => setIsOpened({
    type: 'showSeekList',
    payload: !isOpened.seekList,
  });

  const handleShowFullList = () => {
    setIsOpened({
      type: 'showFullList',
      payload: true,
    });
    setIsOpened({
      type: 'showSeekList',
      payload: false,
    });
  };

  const [dataUnread, setDataUnread] = useState<DataNotification>([]);
  const [data, setData] = useState<DataNotification>([]);

  const renderNotification = useMemo(() => {

    const findUnread = dataUnread?.length > 0 ? dataUnread?.find((v) => v.is_read === false) ?? false : false;
    if (!findUnread) {
      return (
        <img
          src={NotificationIcon as string}
          alt="icon-notification"
          onClick={handleStatusNotification}
          aria-hidden="true"
        />
      );
    }
    return (
      <img
        src={NotificationActiveIcon as string}
        alt="icon-notification-active"
        onClick={handleStatusNotification}
        aria-hidden="true"
      />
    );
  }, [isOpened.seekList, dataUnread]);
  const useRefOuter = useOuterClick(
    (e: MouseEvent) => !['notification'].includes((e.target as HTMLDivElement).id)
      && !['seek_notification_item', 'message'].includes(
        (e.target as HTMLDivElement).className,
      )
      && isOpened.seekList
      && handleStatusNotification(),
  );

  const { fetchNotification, readNotification, removeNotificationById } = useFetchNotification();
  const fetch = async ({
    page,
    pageSize,
    is_read,
    ln,
  }: Readonly<{ page: string; pageSize: string; is_read?: boolean; ln?:string }>) => {
    const response = await fetchNotification({
      page, pageSize, is_read, ln,
    }).catch(
      () => {},
    );
    const result = response.data;
    const dataIsNotEmpty = result?.length > 0;
    if (!dataIsNotEmpty && result?.length < 15) {
      setAllOfDataLoaded(() => ({
        ...allOfDataLoaded,
        [is_read ? 'read' : 'unread']: {
          allLoaded: true,
        },
      }));
    }
    if (is_read && dataIsNotEmpty) {
      const copyData = [...data, ...result];
      setData(copyData);
    } else if (dataIsNotEmpty) {
      const copyData = [...dataUnread, ...result];
      setDataUnread(copyData);
    }
  };

  const readNotificationItem = async (notification_id: string) => {
    try {
      await readNotification({ notificationId: notification_id });
      setDataUnread(removeNotificationById(dataUnread, notification_id));
      setData(removeNotificationById(data, notification_id));
    } catch (error) {
    }
  };

  return (
    <>
      <PopUpListNotif
        show={isOpened.fullList}
        handleRead={readNotificationItem}
        handleModal={setIsOpened}
        fetchData={fetch}
        dataUnread={dataUnread}
        data={data}
        setData={setData}
        setDataUnread={setDataUnread}
        allDataLoaded={allOfDataLoaded}
      />
      <div className="position-relative" id="notification" ref={useRefOuter}>
        <div className="wrapper_notification">{renderNotification}</div>
        <SeekNotification
          data={dataUnread}
          isOpened={isOpened.seekList}
          handleShowList={handleShowFullList}
          handleHideItem={readNotificationItem}
        />
      </div>
    </>
  );
}

export default Index;
